import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PublisherProfileResource, publishersGetProfile } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const usePublisherGetProfile = (
  id: number,
  options: Omit<UseQueryOptions<PublisherProfileResource>, 'queryKey'> = {}
) =>
  useQuery({
    queryFn: () => extractData(publishersGetProfile({ path: { id } })),
    queryKey: ['publishers', 'profile', id],
    ...options,
  });
